import { render, staticRenderFns } from "./TreatmentActiveMedication.vue?vue&type=template&id=b795a4ce&scoped=true&lang=pug&"
import script from "./TreatmentActiveMedication.vue?vue&type=script&lang=js&"
export * from "./TreatmentActiveMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b795a4ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
